import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../utils/api';
import { ArrowLeft } from 'lucide-react';

const NewObjetivoPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const workspaceId = user?.workspaceId || user?.workspace?.id;
  
  const [periods, setPeriods] = useState([]);
  const [formData, setFormData] = useState({
    period_id: '',
    description: '',
    status: 'active'
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    const loadPeriods = async () => {
      try {
        console.log('📅 Loading periods...');
        const response = await api.get('/periods');
        console.log('📅 Periods loaded:', response);
        setPeriods(Array.isArray(response) ? response : []);
      } catch (err) {
        console.error('❌ Error loading periods:', err);
        setError('Error al cargar los períodos');
      }
    };

    loadPeriods();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!workspaceId) {
      setError('No se pudo determinar el workspace');
      return;
    }

    if (!formData.period_id) {
      setError('Por favor selecciona un período');
      return;
    }

    setLoading(true);
    setError('');

    try {
      console.log('💾 Creating objective:', formData);
      await api.post(`/workspaces/${workspaceId}/objectives`, formData);
      navigate('/objetivos');
    } catch (err) {
      console.error('❌ Error creating objective:', err);
      setError(err.error || err.response?.data?.error || 'Error al crear el objetivo');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <button
        onClick={() => navigate('/objetivos')}
        className="flex items-center space-x-2 text-gray-600 hover:text-gray-900"
      >
        <ArrowLeft className="w-4 h-4" />
        <span>Volver</span>
      </button>

      <h1 className="text-2xl font-bold">Nuevo Objetivo</h1>

      {error && (
        <div className="bg-red-50 border border-red-200 rounded-lg p-4 text-red-800">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Período <span className="text-red-500">*</span>
          </label>
          <select
            value={formData.period_id}
            onChange={(e) => setFormData({ ...formData, period_id: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500"
            required
          >
            <option value="">Seleccionar período</option>
            {periods.map(period => (
              <option key={period.id} value={period.id}>
                {period.label}
              </option>
            ))}
          </select>
          {periods.length === 0 && (
            <p className="text-sm text-gray-500 mt-1">
              Cargando períodos...
            </p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Descripción <span className="text-red-500">*</span>
          </label>
          <textarea
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            placeholder="Ejemplo de objetivo"
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500"
            rows={4}
            maxLength={500}
            required
          />
          <p className="text-sm text-gray-500 mt-1">
            {formData.description.length}/500 caracteres
          </p>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Estado
          </label>
          <select
            value={formData.status}
            onChange={(e) => setFormData({ ...formData, status: e.target.value })}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-indigo-500"
          >
            <option value="active">Activo</option>
            <option value="completed">Completado</option>
            <option value="archived">Archivado</option>
          </select>
        </div>

        <div className="flex justify-end space-x-4">
          <button
            type="button"
            onClick={() => navigate('/objetivos')}
            className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-6 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:bg-gray-400"
          >
            {loading ? 'Guardando...' : 'Guardar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewObjetivoPage;
